const url = "https://pride-flag-project.web.app/";

// Object containing color information for various elements
// 0 is a solid, 1 is the pastel/transparent colour
// 2 for horizontal stripes, 3 for vertical stripes,
const colors = {
  red: ["#F77B94", "#FFCBD6", "#FF8FAA", "#FF9DB8"],
  yellow: ["#E3BB01", "#F7E698", "#F2D100", "#F7DC00"],
  blue: ["#9BACF6", "#D9E0FF", "#B1C2FF", "#BFCFFF"],
  purple: ["#AC5AD6", "#E0BEF1", "#C26bE8", "#CF77EF"],
  grey: ["#B8B8B8", "#DFDFDF"],
  grey_2: ["#B8B8B8", "#DFDFDF"],
  dark_grey: ["#B8B8B8", "#DFDFDF"],
  green: ["#65D035", "#C2EFAE", "#77E440", "#84EC49"],
  orange: ["#F69C41", "#FFD9B3", "#FFB24E", "#FFC058"],
  black: ["#292b2c"],
  white: ["#FFFFFF", "#FFFFFF", "#FFFFFF", "#FFFFFF"],
  bg: ["#f5f5f5", "#DFDFDF"],
  she: ["#B8B8B8", "#DFDFDF"],
  they: ["#B8B8B8", "#DFDFDF"],
  he: ["#B8B8B8", "#DFDFDF"],
  other: ["#B8B8B8", "#DFDFDF"],
  na: ["#B8B8B8", "#DFDFDF"],
};

// Array representing the order of colors in a rainbow
const rainbow = ["red", "orange", "yellow", "green", "blue", "purple"];

// Dynamically adding a 'rainbow' property to the 'colors' object
colors.rainbow = [
  // White as the first color in the rainbow
  "#ffffff",
  // Creating a repeating-linear-gradient for the rainbow based on color stops
  `repeating-linear-gradient(to bottom, ${rainbow
    .map(
      // Generating color stops for each color in the rainbow
      (colorKey, i, rainbow) =>
        `${colors[colorKey][1]} ${(100 / rainbow.length) * i}%, ${
          colors[colorKey][1]
        } ${(100 / rainbow.length) * (i + 1)}%`
    )
    .join(", ")})`,
];

// Array representing the order of colors for intersex
const intersex = [
  "purple",
  "purple",
  "yellow",
  "yellow",
  "yellow",
  "purple",
  "purple",
];

// Dynamically adding a 'intersex' property to the 'colors' object
colors.intersex = [
  // White as the first color in the rainbow
  "#AC5AD6",
  // Creating a repeating-linear-gradient for the rainbow based on color stops
  `repeating-linear-gradient(to bottom, ${intersex
    .map(
      // Generating color stops for each color in the rainbow
      (colorKey, i, rainbow) =>
        `${colors[colorKey][1]} ${(100 / rainbow.length) * i}%, ${
          colors[colorKey][1]
        } ${(100 / rainbow.length) * (i + 1)}%`
    )
    .join(", ")})`,
];

// Duration of transitions in milliseconds
const transitionLength = 400;

// Exporting the 'colors' object and 'transitionLength' constant for external use
export { colors, transitionLength, url };
